export class Tip {

    id: number;
    numbers: number[];
    rounds: number;
    stake: number;

    constructor(id: number, numbers: number[], rounds: number, stake: number) {
        this.id = id;
        this.numbers = numbers;
        this.rounds = rounds;
        this.stake = stake;
    }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/domain/tip.ts